module.exports = __webpack_public_path__ + "static/media/hp_14.9b54a4ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_14.jpg
// module id = 5825
// module chunks = 0